import { render, staticRenderFns } from "./ModalLimparNcm.vue?vue&type=template&id=343e64e2&"
import script from "./ModalLimparNcm.vue?vue&type=script&lang=js&"
export * from "./ModalLimparNcm.vue?vue&type=script&lang=js&"
import style0 from "./ModalLimparNcm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports